module.exports = __webpack_public_path__ + "static/media/1972210771_20190214_143759_3244230_resized.23f039bc.jpg";